import { Content } from '~/interfaces/Content';

export const CONTENT_REQUESTED = 'CONTENT_REQUESTED' as const;
export const contentRequested = (locale: string) => ({
  type: CONTENT_REQUESTED,
  locale,
});
export type ContentRequested = ReturnType<typeof contentRequested>;

export const CONTENT_LOADED = 'CONTENT_LOADED' as const;
export const contentLoaded = (contents: Partial<Content>) => ({
  type: CONTENT_LOADED,
  contents,
});

export type ContentLoaded = ReturnType<typeof contentLoaded>;

export type AppActions = ContentRequested | ContentLoaded;
